import { render, staticRenderFns } from "./home-stretches-a45.vue?vue&type=template&id=2b742500&"
import script from "./home-stretches-a45.vue?vue&type=script&lang=js&"
export * from "./home-stretches-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports